'use client';

import { useCallback } from 'react';
import Card from 'components/gruenland/atoms/card/Card';
import { GruenlandHeaderLogo } from 'components/svgr/GruenlandHeaderLogo';
import { GruenlandJuniorHeaderLogo } from 'components/svgr/GruenlandJuniorHeaderLogo';
import { TYPOGRAPHY_STORE_CARD_TITLE } from 'lib/typography';
import { Store } from './types';

interface Props {
  onClick: (store: Store) => void;
  store: Store;
}

const StoreItem = ({ onClick, store }: Props) => {
  const handleClick = useCallback(() => onClick(store), [onClick, store]);
  return (
    <Card className="cursor-pointer" onClick={handleClick}>
      <p className={TYPOGRAPHY_STORE_CARD_TITLE}>{store.name}</p>
      <p className="mb-4 mt-2">
        {store.city}
        <br />
        {store.addr}
      </p>
      <div className="flex gap-4">
        {store.has_grlnd && <GruenlandHeaderLogo height={24} />}
        {store.has_jr && <GruenlandJuniorHeaderLogo height={24} />}
      </div>
    </Card>
  );
};

export default StoreItem;
